import styles from './PhotoPicker.module.scss';
import { IPhoto } from '../PhotoPickerContainer';
import PhotoPickerItem from './PhotoPickerItem/PhotoPickerItem';
import PhotoIcon from '~/assets/svg/newSvg/picture.svg?react';

interface IPhotoPickerProps {
  photos: IPhoto[];
  selectedImages: IPhoto[] | IPhoto | undefined;
  onImageClick: (image: IPhoto) => void;
  isFetching: boolean;
  onUploadClick?: () => void;
  isUploading?: boolean;
  uploadProgress?: number;
}

const PhotoPicker = ({
  photos,
  selectedImages,
  onImageClick,
  isFetching,
  onUploadClick,
  isUploading,
  uploadProgress = 0,
}: IPhotoPickerProps) => {
  return (
    <ul className={styles.photoPicker}>
      {onUploadClick && (
        <li className={styles.uploadCard}>
          <button
            type="button"
            className={styles.uploadButton}
            onClick={onUploadClick}
            disabled={isUploading}
          >
            {isUploading ? (
              <>
                <div
                  className={styles.uploadFill}
                  style={{ height: `${uploadProgress}%` }}
                />
                <PhotoIcon className={styles.uploadIcon} />
                <span className={styles.uploadText}>Загрузить фото</span>
                <span className={styles.uploadPercent}>{uploadProgress}%</span>
              </>
            ) : (
              <>
                <PhotoIcon className={styles.uploadIcon} />
                <span className={styles.uploadText}>Загрузить фото</span>
              </>
            )}
          </button>
        </li>
      )}
      {photos?.map(photo => (
        <PhotoPickerItem
          key={photo.id}
          id={photo.id}
          isSelected={
            Array.isArray(selectedImages)
              ? !!selectedImages?.find(
                  selectedImage => selectedImage.id === photo.id
                )
              : selectedImages?.id === photo.id
          }
          image_url={photo.full_photo_url}
          onImageClick={() => onImageClick(photo)}
          isFetching={isFetching}
        />
      ))}
    </ul>
  );
};

export default PhotoPicker;
